module.exports = __webpack_public_path__ + "img/sub-bio.8225b1fc.png";